<template>
    <div>
        <div class="theme--dark secondary text-lg-center title-bar">
            <h1 class="white--text text-center">Property Sign Up</h1>
        </div>
        <v-card
            max-width="900"
            min-width=""
            class="pa-8 mx-auto my-2"
        >
        <v-stepper v-model="currStep">
            <v-stepper-header class="justify-center">
               <v-stepper-step step="1" :complete="currStep > 1"> Basic</v-stepper-step>
               <v-stepper-step step="2" :complete="currStep > 2"> Contact</v-stepper-step>
               <v-stepper-step step="3" :complete="currStep > 3"> Agreement</v-stepper-step>
               <v-stepper-step step="4" :complete="currStep === 4"> Complete</v-stepper-step>
            </v-stepper-header>
        </v-stepper>
        <v-card-text class="pb-0">
            <div>
                <v-row v-if="currStep === 1">
                    <v-col cols="12">
                        <h3 class="">{{stepTitles[currStep-1]}}</h3>
                    </v-col>
                    <v-col cols="12">
                        <p>Please tell us about your property by filling out the form below.</p>
                    </v-col>
                    <v-col cols="12" md="6" class="pb-0">
                        <v-row>
                            <v-col cols="12">
                                <p>Property Name</p>
                                <v-text-field
                                            outlined dense
                                            v-model="property.name"
                                            :error-messages="nameErrors"
                                            @input="() => {
                                                $v.property.name.$touch()
                                                checkValid()
                                            }"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <p>Property Address</p>
                                <v-text-field outlined dense
                                            v-model="property.address_line_1"
                                            :error-messages="addressErrors"
                                            @input="() => {
                                                $v.property.address_line_1.$touch()
                                                checkValid()
                                            }"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="4">
                                <p>City</p>
                                <v-text-field
                                        outlined
                                        dense
                                        v-model="property.city"
                                        :error-messages="cityErrors"
                                        @input="() => {
                                            $v.property.city.$touch()
                                            checkValid()
                                        }"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <p>State</p>
                                <v-select outlined dense :items="states"
                                    v-model="property.state_id"
                                    item-text="name"
                                    item-value="id"
                                    :error-messages="stateErrors"
                                    @input="() => {
                                        $v.property.state_id.$touch()
                                        checkValid()
                                    }"
                                ></v-select>
                            </v-col>
                            <v-col cols="12" md="4">
                                <p>Zip Code</p>
                                <v-text-field
                                    outlined dense
                                    v-model="property.zip_code"
                                    :error-messages="zipCodeErrors"
                                    @input="() => {
                                        $v.property.zip_code.$touch()
                                        checkValid()
                                    }"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                    </v-col>
                    <v-col cols="12" md="6">
                        <v-row>
                            <v-col cols="12">
                                <p>Property Phone Number</p>
                                <v-text-field outlined dense
                                            type="tel"
                                            v-model="property.phone_number"
                                            placeholder="(999) 999-9999"
                                            :error-messages="phone_numberErrors"
                                            @input="() => {
                                                $v.property.phone_number.$touch()
                                                checkValid()
                                            }"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <p>Property Website</p>
                                <v-text-field outlined dense
                                            v-model="property.website"
                                            :error-messages="websiteErrors"
                                            @input="() => {
                                                $v.property.website.$touch()
                                                checkValid()
                                            }"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" md="6">
                        <h4 class="input-title">Where can we send you details about new leads?</h4>
                        <p>Referral E-mail</p>
                        <v-text-field outlined dense
                                      v-model="property.referral_email"
                                      :error-messages="referral_emailErrors"
                                      @input="() => {
                                            $v.property.$touch()
                                            checkValid()
                                        }"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <h4 class="input-title">Where do we e-mail the invoice?</h4>
                        <p>Invoicing E-mail</p>
                        <v-text-field outlined dense
                                      v-model="property.invoice_email"
                                      :error-messages="invoice_emailErrors"
                                      @input="() => {
                                            $v.property.$touch()
                                            checkValid()
                                        }"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row v-if="currStep === 2">
                    <v-col cols="12">
                        <h3 class="">{{stepTitles[currStep-1]}}</h3>
                    </v-col>
                    <v-col cols="12">
                        <p>Who’s the main point of contact for this property?</p>
                    </v-col>
                    <v-col cols="12">
                        <ContactInformation />
                    </v-col>
                </v-row>
                <v-row v-if="currStep === 3">
                     <v-col cols="12">
                        <h3 class="">{{stepTitles[currStep-1]}}</h3>
                    </v-col>
                    <v-col cols="12">
                        <p>Please read and fill out the referral agreement below to complete sign up.</p>
                    </v-col>
                    <v-col cols="12">
                        <Agreement :price=price />
                    </v-col>
                </v-row>
                <v-row v-if="currStep === 4">
                    <div class="mx-auto">
                        <h4>Thank you for partnering with EDUrent! An agent will contact you soon to finalize setup.</h4>
                    </div>
                </v-row>
                <v-row class="d-flex pt-0" v-if="currStep < 4">
                    <v-col cols="12" md="6" class="pb-0 d-flex justify-end" :class="$vuetify.breakpoint.smAndDown ? 'justify-center' : 'justify-end'">
                        <v-btn
                            color="error"
                            class="next-btn btn-edurent "
                            height="45"
                            width="163"
                            depressed
                            to="/partner-with-us"
                            v-if="currStep <= 1"
                        >
                            Cancel
                        </v-btn>
                        <v-btn
                            color="primary"
                            class="btn-edurent"
                            height="45"
                            width="163"
                            outlined
                            depressed
                            v-else
                            @click="changeStep('down')"
                        >
                            Go Back
                        </v-btn>
                    </v-col>
                    <v-col cols="12" md="6" class="pb-0 d-flex justify-start" :class="$vuetify.breakpoint.smAndDown ? 'justify-center' : 'justify-start'">
                        <v-btn
                                v-if="currStep === steps"
                                color="primary"
                                class="next-btn btn-edurent"
                                height="45"
                                width="163"
                                depressed
                                :disabled="!agreementComplete || !isValid"
                                @click="submit()"
                        >
                            Submit
                        </v-btn>
                        <v-btn
                                v-else
                                color="primary"
                                class="next-btn btn-edurent"
                                height="45"
                                width="163"
                                depressed
                                :disabled="currStep === steps || !isValid"
                                @click="changeStep('up')"
                        >
                            Next Step
                        </v-btn>
                    </v-col>
                </v-row>
            </div>
        </v-card-text>
        </v-card>
    </div>
</template>

<script>
    import { required, email} from 'vuelidate/lib/validators'
    import PropertyService from '../services/property.service'
    import ContactInformation from '../components/PropertySignUp/ContactInformation.vue'
    import Agreement from '../components/PropertySignUp/Agreement.vue'
import { formatPhoneNumber } from '../utils/utils'
    export default {
        name:"PropertySignUp",

        props: {
            price: {
                type: Number,
                default: 299,
            },
        },

        data() {
            return {
                complete: false,
                property: {},
                currStep: 1,
                steps: 3,
                stepTitles: ["Basic Information", "Contact Information", "Referral Agreement"]
            }
        },
        components: {
            ContactInformation,
            Agreement
        },
        validations: {
            property: {
                name: { required },
                address_line_1: {required},
                website: {required},
                referral_email: {required, email},
                invoice_email: {required, email},
                phone_number: {required},
                city: {required},
                state_id: {required},
                zip_code: {required}
            }
        },
        methods: {
            initProperty() {
                this.property = {
                    name: "",
                    address_line_1: "",
                    website: "",
                    referral_email: "",
                    invoice_email: "",
                    phone_number: "",
                    pending: 1,
                    is_active: 0,
                    flat_rate: Number(this.price)
                }
            },
            checkValid() {
                this.property.phone_number = formatPhoneNumber(this.property.phone_number)
                if(this.$v.property.$invalid) {
                    this.$store.commit('setValidInputs', false)
                } else {
                    this.$store.commit('setValidInputs', true)
                }
            },
            changeStep(direction = "up") {
                this.$v.property.$touch();
                if (this.$v.property.$invalid) {
                    this.$store.commit('setSnackbar', {
                        show: true,
                        message: 'Mandatory field(s) are missing.',
                        color: 'red'
                    });
                } else {
                    if(direction === "up") {
                        this.currStep ++;
                        if (this.currStep === 1) {
                            this.$store.commit('setProperty', this.property)
                        }
                    }else{
                        this.currStep --;
                        this.checkValid()
                    }
                }
            },
            async submit() {
                const agreement = this.$store.getters.getAgreement;
                const property = await PropertyService.addNewProperty({
                    property: this.property,
                    contacts: [this.$store.getters.getContacts],
                    agreement: agreement
                });

                if (property) {
                    this.complete = true;
                    this.currStep++;
                }
            }
        },
        computed: {
            isValid() {
                return this.$store.getters.getValidInput
            },
            agreementComplete() {
                return this.$store.getters.getAgreementComplete
            },
            states() {
              return this.$store.getters.getBusiness
                  && this.$store.getters.getBusiness.countries
                  ? this.$store.getters.getBusiness.countries[0].states
                  : [];
            },
            nameErrors () {
                const errors = []
                if (!this.$v.property.name.$dirty) return errors
                !this.$v.property.name.required && errors.push('Property name is required')
                return errors
            },
            addressErrors () {
                const errors = []
                if (!this.$v.property.address_line_1.$dirty) return errors
                !this.$v.property.address_line_1.required && errors.push('Address is required')
                return errors
            },
            websiteErrors () {
                const errors = []
                if (!this.$v.property.website.$dirty) return errors
                !this.$v.property.website.required && errors.push('Website is required')
                return errors
            },
            referral_emailErrors () {
                const errors = []
                if (!this.$v.property.referral_email.$dirty) return errors
                !this.$v.property.referral_email.email && errors.push('A valid email is required')
                !this.$v.property.referral_email.required && errors.push('Referral e-mail is required')
                return errors
            },
            invoice_emailErrors () {
                const errors = []
                if (!this.$v.property.invoice_email.$dirty) return errors
                !this.$v.property.invoice_email.email && errors.push('A valid email is required')
                !this.$v.property.invoice_email.required && errors.push('Invoice e-mail is required')
                return errors
            },
            phone_numberErrors () {
                const errors = []
                if (!this.$v.property.phone_number.$dirty) return errors
                !this.$v.property.phone_number.required && errors.push('Phone Number is required')
                return errors
            },
            cityErrors () {
                const errors = []
                if (!this.$v.property.city.$dirty) return errors
                !this.$v.property.city.required && errors.push('City is required')
                return errors
            },
            stateErrors () {
                const errors = []
                if (!this.$v.property.state_id.$dirty) return errors
                !this.$v.property.state_id.required && errors.push('State is required')
                return errors
            },
            zipCodeErrors () {
                const errors = []
                if (!this.$v.property.zip_code.$dirty) return errors
                !this.$v.property.zip_code.required && errors.push('Zip Code is required')
                return errors
            },
        },
        beforeMount () {
            this.initProperty()
            this.checkValid()
        },
    }
</script>

<style lang="scss" scoped>

p {
    font-family: Poppins;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
}

h4 {
    font-family: Poppins;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
}

.step-title {
    background-color: #1976d2 !important;
    color: white;
    border-bottom: 0;
    width: 30vw;
    margin: -1em auto 0 auto;
    border-radius: 10px;
    font-size: 2em;
    padding: 0.3em 0
}

.step-title-mobile {
    background-color: #1976d2 !important;
    color: white;
    border-bottom: 0;
    width: 70%;
    margin: -1.5em auto 0 auto;
    border-radius: 10px;
    font-size: 2em;
    padding: 0.3em 0
}

.input-title {
    min-height: 50px;
}

</style>
